module.exports = __webpack_public_path__ + "img/company_icon4.3c5958fd.png";